import React from 'react';
import { useStripe } from 'shared/hooks';
import { Box, Flex, Heading, Icon, Link, Text } from '@televet/kibble-ui';

export const StripePayoutAccount = (): JSX.Element | null => {
  const { account, login } = useStripe();

  if (!account?.defaultAccount) return null;

  const { bankName, last4, currency } = account.defaultAccount;

  return (
    <Box mb={5}>
      <Heading size="md" mb={3}>
        Connected Bank Account
      </Heading>
      <Flex align="center" mb={3}>
        <Icon name="bank" size="xl" />
        <Box ml={3}>
          <Text as="p" size="sm">
            {bankName}
          </Text>
          <Text as="p" size="xs" variant="subtle">
            *******{last4} ({currency.toUpperCase()})
          </Text>
        </Box>
      </Flex>
      <Link isExternal iconProps={{ name: 'externalLink' }} onClick={login} size="sm">
        Stripe Account Overview
      </Link>
    </Box>
  );
};
